export const translationUploadData_en_part1 = {
  expirationPicker: "Date & Time",
  errorFetchingIndexes: "Error fetching indexes. Please try again.",
  errorFetchingData: "Error fetching data. Please try again.",
  errorConversations: "Error fetching conversations. Please try again.",
  tokenChatbotMissing: "Token or chatbotID not found",
  convoResolved: "Conversation marked as resolved.",
  errorUpdatingConvo: "Error updating conversation.",
  titleRequired: "Title is required.",
  titleLimit: "Title cannot exceed 50 characters.",
  tokenNotFound: "Token not found.",
  errorUpdatingData: "Error updating data.",
  dataUpdated: "Data updated in",
  dataAdded: "Data added to",
  errorUpdating: "Error updating data in",
  errorAdding: "Error adding data to",
  dataDeletedFrom: "Data deleted from",
  errorDeletingFrom: "Error deleting data from",
  dataUploaded: "Data uploaded to",
  errorUploadingTo: "Error uploading to",
  convoMarkedResolved: ". Conversation marked as resolved.",
  myInfoChunks: "My Info Chunks",
  lackingInfoConvos: "Conversations Missing Info",
  conversationDetails: "Conversation Details",
  uploadDataHeader: "Upload and Manage Information",
  addNew: "Add New",
  addNewInfo: "Add New Info",
  noConversationSelected: "No conversation selected.",
  deleteLabel: "Delete",
  conversationID: "Conversation ID",
  dateLabel: "Date",
  topicLabel: "Topic",
  uncategorized: "Uncategorized",
  requiredTitlePlaceholder: "Enter a title for your information",
  uploadInfoPlaceholder: "Enter the information you want to upload",
  uploadFormattingToolbar: "Text formatting",
  uploadFormattingBold: "Bold",
  uploadFormattingItalic: "Italic",
  uploadFormattingHint: "Use the buttons for bold or italic text.",
  chunkOverridesSection: "Chatbot overrides",
  chunkOverridesHint:
    "Select a part of the text and click Add override — then choose which chatbots get their own version of that part. Overridden parts are highlighted: hover to see, click to edit. Overrides only take effect for chatbots that use this knowledge base.",
  overridesAdd: "Add override",
  overridesEditorIntro: "Pick the chatbots that should say something else here.",
  overridesRemove: "Remove",
  overridesEmptyHint: "No overrides — all chatbots use the shared text.",
  overridesTextPlaceholder: "Version of the content for this chatbot",
  overridesSelectionMissing: "Select the part of the text you want to override first.",
  overridesOriginalLabel: "Original",
  overridesOverrideLabel: "Replacement for this chatbot",
  overridesStaleWarning:
    "The original text no longer exists in the shared version — this override is inactive.",
  overridesEntireTextLabel: "Entire text is replaced for this chatbot",
  overridesPreviewLabel: "Show the text this chatbot will use",
  overridesDone: "Done",
  overridesSearchChatbots: "Search chatbots",
  overridesNoChatbotMatches: "No chatbots match that search.",
  overridesAddAllChatbots: "Add all",
  overridesCountHint: "Chatbots with their own version of this part / chatbots that can have one",
  chatbot: "Chatbot",
  fileUploadChooseFile: "Choose file",
  updating: "Updating...",
  uploading: "Uploading...",
  update: "Update",
  upload: "Upload",
  cancel: "Cancel",
  removing: "Removing...",
  remove: "Remove",
  addNotesHere: "Add notes here...",
  dataDeletedMessage: "Data deleted from",
  errorDeletingMessage: "Error deleting data from",
  deleteFromAll: "Delete from all knowledge bases",
  confirmDeleteAll: "Are you sure you want to delete from all knowledge bases?",
  deletedFromAll: "Deleted from all knowledge bases",
  expiresAt: "Expires",
  sortByLabel: "Sort by:",
  sortByDateNewest: "Date (Newest First)",
  sortByTitleAZ: "Title (A-Z)",
  companyInfo: "Company Information",
  livechat: "Livechat",
  typeYourAnswer: "Write your answer here...",
  previous: "Previous",
  next: "Next",
  agentNameLabel: "Your Agent Name",
  agentNamePlaceholder: "Enter your agent name",
  saveAgentName: "Save Agent Name",
  agentNameSaved: "Agent name saved!",
  searchConversationsPlaceholder: "Search conversations, IDs, or user IDs...",
  pageLabel: "Page",
  userIDLabel: "User ID",
  freshdeskFormVisualOnly: "This is only a visual representation of the contact form",
  addNotesPlaceholder: "Add notes here...",
  freshdeskContactSupport: "Contact customer service",
  freshdeskYourEmail: "Your email:",
  freshdeskEmailPlaceholder: "example@mail.com",
  freshdeskSupportMessage: "Message to customer service:",
  freshdeskMessagePlaceholder: "Write your message here...",
  freshdeskUploadImageOptional: "Upload image (optional):",
  freshdeskChooseFile: "Choose file",
  freshdeskNoFileChosen: "No file chosen",
  freshdeskSendInquiry: "Send inquiry",
  // Leadgen form translations
  // Leadgen form translations
  leadgenContactForm: "Contact Form",
  leadgenNameLabel: "Your Name",
  leadgenNamePlaceholder: "Enter your name",
  leadgenEmailLabel: "Your Email",
  leadgenEmailPlaceholder: "Enter your email",
  leadgenSubmitButton: "Submit",
  leadgenFormVisualOnly: "This form is for display purposes only in the dashboard",
  searchInfoChunks: "Search your info chunks...",
  selectOption: "Select the option",
  selectKnowledgebase: "Select knowledgebase",
  selectKnowledgebaseTooltip:
    "Choose which knowledge database to store the content in - for example products for product info and general for general information. If in doubt, add both.",
  deadlineOptional: "Deadline (optional)",
  optional: "Optional",
  expirationDate: "Expiration Date",
  scheduleUpload: "Schedule Upload",
  scheduleTime: "Scheduled time",
  selectScheduleTime: "Select upload time",
  scheduleDateTime: "Date and time",
  immediateUpload: "Upload now",
  scheduledUpload: "Scheduled upload",
  scheduleRequired: "Scheduled time is required",
  scheduleTimeInPast: "Scheduled time must be in the future",
};
